import type { ImageProps as NextImageProps } from 'next/image'
import NextImage from 'next/image'

import { useConfig } from '../../core'

export type ImageProps = NextImageProps

/**
 * Image component
 * Switches between the raw `img` tag and `next/image`
 */
export const Image = ({ src, fill, priority, ...props }: ImageProps) => {
  const { nextjs } = useConfig()

  if (nextjs && !nextjs.disableNextImage) {
    return (
      <NextImage
        src={src}
        fill={fill}
        priority={priority}
        {...props}
        unoptimized={nextjs.disableImageOptimization}
      />
    )
  }

  return <img src={src as string} {...props} />
}
